export default __webpack_public_path__ + "static/og-img-1.5M-4aaa70c1cb206387bcf17ad91ebe5698.png";